(() => {
    function isoToFlagEmoji(iso) {
    return iso
      .toUpperCase()
      .replace(/./g, char =>
        String.fromCodePoint(127397 + char.charCodeAt())
      );
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".sf-select-custom--option").forEach(option => {
      const iso = option.dataset.iso;
      if (!iso) return;

      const flagEl = option.querySelector(".country-flag");
      if (flagEl) {
        flagEl.textContent = isoToFlagEmoji(iso);
      }
    });
      document.querySelectorAll(".country-flag-option").forEach(option => {
      const iso = option.dataset.iso;
      if (!iso) return;
        option.textContent = isoToFlagEmoji(iso);
    });
  });
})();
